import React from "react"
import TooltipData from "./TooltipData"
import "./index.scss"
import { ChartTooltipProps } from "./domain"
import { isDefined } from "helpers/objects"
import { getVariantCurrent, getVariantPrevious } from "../../utils/utils"

const ChartTooltip: React.FC<ChartTooltipProps> = (props) => {
	const { data } = "points" in props ? props.points[0] : props.point
	const { info } = data
	const { reordered } = props
	const {
		currentAmount: currentSales,
		currentDate,
		percentageGrowth,
		previousAmount: previousSales,
		previousDate,
	} = info

	const previousPercentageGrowth = isDefined(currentDate)
		? null
		: percentageGrowth

	return (
		<div className="chart-tooltip-container">
			<TooltipData
				variant={getVariantPrevious(reordered)}
				sale={previousSales}
				date={previousDate}
				percentageGrowth={previousPercentageGrowth}
				isPenetrationMetric={props.isPenetrationMetric}
			/>
			<TooltipData
				variant={getVariantCurrent(reordered)}
				sale={currentSales}
				date={currentDate}
				percentageGrowth={percentageGrowth}
				isPenetrationMetric={props.isPenetrationMetric}
			/>
		</div>
	)
}

export default ChartTooltip
